import { Text } from '@thanx/uikit/text'
import { buildTranslate } from 'locales'
import React from 'react'
import { Col, Row } from 'react-bootstrap-five'

const t = buildTranslate('games')

const EmptyGameState: React.FC = () => {
  return (
    <Row className="mb-4">
      <Col>
        <div
          className="p-4 text-center"
          style={{
            border: 'none',
          }}
        >
          <Text.BodyText3 color="#6a747f">
            {t('enabled.empty.message')}
          </Text.BodyText3>
        </div>
      </Col>
    </Row>
  )
}

export default EmptyGameState
